import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import {
  DataService,
  HomeSkills,
  ProgrammingLanguages,
} from "src/app/data.service";
import { ThemeService } from "src/app/theme.service";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-home-skills",
  templateUrl: "./home-skills.component.html",
  styleUrls: ["./home-skills.component.css"],
})
export class HomeSkillsComponent implements OnInit {
  homeSkills: HomeSkills;
  faInfoCircle = faInfoCircle;

  @Input() navigate;

  constructor(
    public dataService: DataService,
    public themeService: ThemeService,
    private router: Router
  ) {
    this.homeSkills = dataService.homeSkills;
  }

  ngOnInit(): void {}

  getKeys = (obj) => Object.keys(obj);

  getObj = (origin) => {
    switch (origin) {
      case "MEARN":
        return [...this.homeSkills.MEARN];
      case "LANG":
        return [...this.homeSkills.LANG];
      case "HYBRID":
        return [...this.homeSkills.HYBRID];
    }
  };

  getHeading = (origin) => {
    switch (origin) {
      case "MEARN":
        return "Web Development";
      case "LANG":
        return "Programming Languages";
      case "HYBRID":
        return "App Development";
    }
  };

  putObj = (newObj, origin) => {
    switch (origin) {
      case "MEARN":
        this.homeSkills.MEARN = [...newObj];
        break;
      case "LANG":
        this.homeSkills.LANG = [...newObj];
        break;
      case "HYBRID":
        this.homeSkills.HYBRID = [...newObj];
        break;
    }
  };

  flip = (index, value, origin) => {
    const skills_obj: Array<ProgrammingLanguages> = this.getObj(origin);
    skills_obj[index].flag = value;
    this.putObj(skills_obj, origin);
  };
}
